import { useSelector } from "react-redux";
import { messages, STATUS_CONSTANTS, COMMON_CONSTANTS } from "./NewBornConstants"
import { status_type } from "@constants/vhndExecutionConstant"
import { diffBetweenTwoDays } from "@utils/commonUtils";
import dayjs from "dayjs";
import { RootState } from "@store/reducers";


const isRrequired = (day:number, dateOfBirth:any)=>{
  const days = diffBetweenTwoDays(dateOfBirth, dayjs(), 'days');
  return day>=days ? true:false
}
export const isNewBornFormValidated = (newBornDetailsFormState: any, setNewBornDetailsFormState: any, formValidationError: boolean[], activeIndex: number, dateOfBirth:any, parentIllness:any, newBornDetailsFormData:any) => {
  let isError = false
  if (!newBornDetailsFormState.babyCried.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        babyCried: {
          ...preState.babyCried,
          isError: true,
          message: messages.emptyFieldErrorMessage
        }
      }
    })
    isError = true
  }
  if (newBornDetailsFormState.babyCried.value != status_type.yes.status_name && newBornDetailsFormState.babyCried.value != '' && !newBornDetailsFormState.referred.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        referred: {
          ...preState.referred,
          isError: true,
          message: messages.emptyFieldErrorMessage
        }
      }
    })
    isError = true
  }
  if (!newBornDetailsFormState.isChildAdmitted.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        isChildAdmitted: {
          ...preState.isChildAdmitted,
          isError: true,
          message: messages.emptyFieldErrorMessage
        }
      }
    })
    isError = true
  }
  if (!newBornDetailsFormState.birthDefectSeen.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        birthDefectSeen: {
          ...preState.birthDefectSeen,
          isError: true,
          message: messages.visibleBirthDefectErrorMessage
        }
      }
    })
    isError = true
  }
  if (newBornDetailsFormState.birthDefectSeen.value != STATUS_CONSTANTS.NO_DEFECT && newBornDetailsFormState.birthDefectSeen.value != '' && !newBornDetailsFormState.ifDefectIdentified.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        ifDefectIdentified: {
          ...preState.ifDefectIdentified,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }
  if (newBornDetailsFormState.ifDefectIdentified.value === STATUS_CONSTANTS.TREATED && !newBornDetailsFormState.methodOfTreatment.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        methodOfTreatment: {
          ...preState.methodOfTreatment,
          isError: true,
          message: messages.treatmentMethodErrorMessage
        }
      }
    })
    isError = true
  }
  if (!newBornDetailsFormState.breastFeeding.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        breastFeeding: {
          ...preState.breastFeeding,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }

  if (newBornDetailsFormData.isTestedForHIV['#required'] &&!newBornDetailsFormState.isTestedForHIV.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        isTestedForHIV: {
          ...preState.isTestedForHIV,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }
  
  if (newBornDetailsFormData.isNevirapineSyrupStarted['#required'] && !newBornDetailsFormData.isNevirapineSyrupStarted['#isDisabled'] && !newBornDetailsFormState.isNevirapineSyrupStarted.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        isNevirapineSyrupStarted: {
          ...preState.isNevirapineSyrupStarted,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }
  if (newBornDetailsFormData.referredToNacpReferralFacility['#required'] && !newBornDetailsFormState.referredToNacpReferralFacility.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        referredToNacpReferralFacility: {
          ...preState.referredToNacpReferralFacility,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }
  if (newBornDetailsFormData.hbigVaccination['#required'] && !newBornDetailsFormState.hbigVaccination.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        hbigVaccination: {
          ...preState.hbigVaccination,
          isError: true,
          message: messages.validDateErrorMessage
        }
      }
    })
    isError = true
  }
  if (!newBornDetailsFormState.whetherAefiReported.value) {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        whetherAefiReported: {
          ...preState.whetherAefiReported,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }

  if (!newBornDetailsFormState.syphilisTest.value && parentIllness?.service_report_code==='reactive') {
    setNewBornDetailsFormState((preState: any) => {
      return {
        ...preState,
        syphilisTest: {
          ...preState.sy,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }


  formValidationError[activeIndex] = isError;
  return isError
}

export const isDeathDetailsFormValidated = (deathDetailsFormState: any, setDeathDetailsFormState: any, formValidationError: boolean[], activeIndex: number) => {
  let isError = false
  if (!deathDetailsFormState.deathHappenedDueTo.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        deathHappenedDueTo: {
          ...preState.deathHappenedDueTo,
          isError: true,
          message: messages.validOptionsErrorMessage
        }
      }
    })
    isError = true
  }
  if (!deathDetailsFormState.dateOfDeath.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        dateOfDeath: {
          ...preState.dateOfDeath,
          isError: true,
          message: messages.validDateErrorMessage
        }
      }
    })
    isError = true
  }
  if (deathDetailsFormState.deathHappenedDueTo.value != COMMON_CONSTANTS.DEATH_DUE_TO_AEFI && deathDetailsFormState.deathHappenedDueTo.value != '' && !deathDetailsFormState.probableCauseOfDeath.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        probableCauseOfDeath: {
          ...preState.probableCauseOfDeath,
          isError: true,
          message: messages.probableCauseOfdeathErrorMessage
        }
      }
    })
    isError = true
  }
  if (!deathDetailsFormState.timeOfDeath.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        timeOfDeath: {
          ...preState.timeOfDeath,
          isError: true,
          message: messages.validDateErrorMessage
        }
      }
    })
    isError = true
  }
  if (!deathDetailsFormState.placeOfDeath.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        placeOfDeath: {
          ...preState.placeOfDeath,
          isError: true,
          message: messages.placeOfdeathErrorMessage
        }
      }
    })
    isError = true
  }
  if (!deathDetailsFormState.notificationSetByAsha.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        notificationSetByAsha: {
          ...preState.notificationSetByAsha,
          isError: true,
          message: messages.notificationSetByAshaErrorMessage
        }
      }
    })
    isError = true
  }
  if (!deathDetailsFormState.FBIRCompletedByANM.value) {
    setDeathDetailsFormState((preState: any) => {
      return {
        ...preState,
        FBIRCompletedByANM: {
          ...preState.FBIRCompletedByANM,
          isError: true,
          message: messages.FBIRCompltedByANMErrorMessage
        }
      }
    })
    isError = true
  }
  
  
  formValidationError[activeIndex] = isError;
  return isError
}